import TableHeader from '../Header';
import TableWrapper from '../Wrapper';
import { TableProvider } from '../context';

import TableBody from './Body'

export default function Table() {
  return <TableProvider>
    <TableWrapper>
      <TableHeader />
      <TableBody />
    </TableWrapper>
  </TableProvider>
}
